import {React, useEffect} from "react";
import './style/HomerMerge.scss'
import HeroSection from "./HomeComponents/HeroSection";
import SecondSection from "./HomeComponents/SecondSection";
import ServicesComponent from "./HomeComponents/ServicesComponent";
import ContactUs from "./HomeComponents/ContactUs";

export default function Home() {
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  return (
    <>
      <HeroSection />
      <SecondSection />
      <ServicesComponent />
      <ContactUs />
    </>
  );
}
